export default {
  title: 'Manage Contest',
  description: 'Manage your contest settings and details',
  overview:
    'Invite users, manage entrants and customize your contest settings. Everything you need to manage your contest is right here.',
  breadcrumbs: {
    manageContest: 'Manage Contest',
    manageContestDescription: 'Manage your contest settings and details',
  },
  copyInviteLink: 'Copy invite link',
  navigation: {
    manageContest: {
      title: 'Manage Contest',
      description: 'Manage your contest settings and details',
    },
    invitesManager: {
      title: 'Invites Manager',
      description: 'Invite people to your contest. Track the status of your invites.',
    },
    entrantsManager: {
      title: 'Entrants Manager',
      description: 'Manage your entrants and track their performance.',
    },
    settings: {
      title: 'Settings',
      description: 'Edit contest details and advanced settings.',
    },
  },
};
